import { render, staticRenderFns } from "./resulting.vue?vue&type=template&id=2f4bd146&scoped=true&"
import script from "./resulting.vue?vue&type=script&lang=js&"
export * from "./resulting.vue?vue&type=script&lang=js&"
import style0 from "./resulting.vue?vue&type=style&index=0&id=2f4bd146&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f4bd146",
  null
  
)

export default component.exports